/**
 * 符号拼接在金额后面的货币符号
 */
const suffixCurrencies = ['€'];
/**
 * 货币代码和货币符号的映射
 */
const currencySymbolMap = new Map([
    ['EUR', '€'],
    ['NZD', '$'],
    ['AUD', '$'],
    ['CAD', 'C$'],
    ['USD', '$'],
    ['HRK', 'kn'],
    ['CZK', 'Kč'],
    ['DKK', 'kr'],
    ['NOK', 'kr'],
    ['SEK', 'kr'],
    ['ISK', 'kr'],
    ['HUF', 'Ft'],
    ['PLN', 'zł'],
    ['CHF', 'Fr'],
    ['TRY', '₺'],
    ['GBP', '£'],
    ['BGN', 'лв'],
    ['RSD', 'Дин'],
    ['RUB', '₽'],
    ['PHP', '₱']
]);
const NO_DECIMAL_SYMBOL = 'N'; // 标识忽略小数
/**
 * 格式化 money
 * @param amount 金额
 * @param priceRuler 货币规则、货币符号或者货币代码，如果传入货币符号或者货币代码，按老的规则展示
 * @param fixedDigits 保留小数位数，默认2，如果传入负数，表示不处理
 * @returns
 */
function formatPrice(amount, priceRuler, fixedDigits = 2) {
    if (typeof amount === 'undefined' || amount === null) {
        return '';
    }
    if (fixedDigits >= 0) {
        const amountValue = typeof amount === 'number' ? amount : parseFloat(amount);
        amount = amountValue.toFixed(fixedDigits);
    }
    if (priceRuler.startsWith('#')) {
        //新版格式化规则
        let finalePriceRuler = priceRuler.slice(1);
        if (finalePriceRuler.endsWith('#')) {
            finalePriceRuler = finalePriceRuler.slice(0, -1);
        }
        const priceRulers = finalePriceRuler.split('#');
        const amounts = amount.toString().split('.');
        const decimalDot = priceRulers[3] || '.';
        const noDecimal = amounts[1] && decimalDot !== NO_DECIMAL_SYMBOL;
        const newAmount = `${amounts[0].replace(/\B(?=(\d{3})+(?!\d))/g, priceRulers[2] || ',')}${noDecimal ? decimalDot + amounts[1] : ''}`;
        if (priceRulers[0] === '>') {
            return `${newAmount}${priceRulers[1] || ''}`;
        }
        else {
            return `${priceRulers[1] || ''}${newAmount}`;
        }
    }
    else {
        const symbol = currencySymbolMap.get(priceRuler) || priceRuler;
        const symbolSuffix = suffixCurrencies.includes(symbol);
        if (symbolSuffix) {
            return `${amount}${symbol}`;
        }
        else {
            return `${symbol}${amount}`;
        }
    }
}
export { formatPrice };
